import { signalStore } from '@ngrx/signals';
import { withEntities } from '@ngrx/signals/entities';

import { withSelectedEntity } from '../../../shared/store/selected-entity.feature';
import { Jalon } from '../../models/jalon.model';
import { avecMéthodesJalon } from './jalon.methods';

export const JalonStore = signalStore(
  { providedIn: 'root' },
  withEntities<Jalon>(),
  withSelectedEntity(),
  avecMéthodesJalon(),
);
